import { render, staticRenderFns } from "./PatientCharts.vue?vue&type=template&id=ce8d29d8&"
import script from "./PatientCharts.vue?vue&type=script&lang=js&"
export * from "./PatientCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports